/***************************************************************************************/ 
 /* This file is generated. Do not edit by hand unless you 100% know what you're doing.. */ 
 /***************************************************************************************/ 
 
export enum TenantPropKey { 
    AccountNumber = "AccountNumber",
    Id = "Id",
    SMSOptIn = "SMSOptIn",

}